import React from 'react';
import { Button } from '@planne-software/uni/Button';
import { IconDownload } from '@planne-software/uni/icons';

import { useTranslate } from '@src/core/hooks';

import type { VoucherBlockView } from './useReservationVouchersModal';
import {
  VoucherBlockRoot,
  VoucherBlockTitle,
  VoucherField,
  VoucherFieldLabel,
  VoucherFieldRow,
  VoucherFieldValue,
} from '../styles';

export type VoucherBlockProps = {
  block: VoucherBlockView;
  /** The combined layout downloads from the footer instead, so it has no own action. */
  showsDownload: boolean;
  loading: boolean;
  onDownload: () => void;
};

export const VoucherBlock = (props: VoucherBlockProps) => {
  const { block, showsDownload, loading, onDownload } = props;
  const { i18n } = useTranslate();

  return (
    <VoucherBlockRoot data-testid={`voucher-block-${block.key}`}>
      <VoucherBlockTitle>{block.tariffsLabel}</VoucherBlockTitle>

      <VoucherFieldRow>
        <VoucherField>
          <VoucherFieldLabel>{i18n('checkout_vouchers_modal_code')}</VoucherFieldLabel>
          <VoucherFieldValue>{block.code}</VoucherFieldValue>
        </VoucherField>

        <VoucherField>
          <VoucherFieldLabel>{i18n('checkout_vouchers_modal_password')}</VoucherFieldLabel>
          <VoucherFieldValue>{block.secret}</VoucherFieldValue>
        </VoucherField>

        <VoucherField>
          <VoucherFieldLabel>{i18n('checkout_vouchers_modal_status')}</VoucherFieldLabel>
          <VoucherFieldValue>{block.statusLabel}</VoucherFieldValue>
        </VoucherField>
      </VoucherFieldRow>

      {showsDownload ? (
        <Button
          data-testid={`voucher-download-${block.key}`}
          type='button'
          variant='outlined'
          color='neutral'
          size='sm'
          fullWidth
          loading={loading}
          disabled={!block.isDownloadable || loading}
          startSlot={<IconDownload size={16} aria-hidden />}
          onClick={onDownload}
        >
          {i18n('checkout_vouchers_modal_download')}
        </Button>
      ) : null}
    </VoucherBlockRoot>
  );
};

export default VoucherBlock;
